'use strict';

;( ( $ ) => {

	document.addEventListener( 'alpine:init', () => {

		Alpine.data( 'slider', () => ({

			init() {
				const sliderEl   = this.$el;
				const sliderName = this.$el.dataset.slick;
				const $slider    = $( this.$el ).find( '.slides' );
				const sliderI    = this.$el.querySelector( '.slider-i' );
				const options    = {
					appendArrows  : this.$el.querySelector( '.slick-arrows-container' ),
					arrows        : true,
					cssEase       : 'ease-in-out',
					mobileFirst   : true,
					slidesToScroll: 1,
					slidesToShow  : 1,
					speed         : 1250,
				};

				if ( window.matchMedia( '( prefers-reduced-motion: reduce )' ).matches ) {
					options.fade = true;
				}

				// For the "news-block" slider, destroy at 991px+, and set some
				// other options.
				if ( 'news-block' === sliderName ) {
					options.appendDots    = this.$el.querySelector( '.slick-dots-container' );
					options.autoplay      = true;
					options.autoplaySpeed = 5000;
					options.dots          = true;
					options.infinite      = false;
					options.speed         = 750;
					options.responsive    = [
						{
							breakpoint: 991,
							settings  : 'unslick',
						},
					];
				} else if ( 'text-grid' === sliderName ) {
					options.responsive = [
						{
							breakpoint: 767,
							settings  : {
								slidesToShow: 2,
							}
						},
						{
							breakpoint: 991,
							settings  : 'unslick',
						}
					];
				} else if ( 'testimonials' === sliderName ) {
					options.appendDots    = this.$el.querySelector( '.slick-dots-container' );
					options.arrows        = false;
					options.autoplay      = true;
					options.autoplaySpeed = 5000;
					options.dots          = true;
					options.pauseOnHover  = false;
				} else if ( 'slider-block' === sliderName ) {
					options.cssEase = 'ease-in-out';
				}

				if ( ! $slider.hasClass( 'slick-initialized' ) ) {

					$slider
						.on( 'init', () => {
							sliderEl.classList.remove( 'opacity-0' );
							if ( null !== sliderI ) sliderI.textContent = 1;
							$( window ).trigger( 'resize' );
						})
						.on( 'beforeChange', ( event, slick, currentSlide, nextSlide ) => {

							// For the testimonials slider, adjust the
							// --dot-animation-time to 6250ms.
							if ( 'testimonials' === sliderName ) {
								const dotEl = sliderEl.querySelector( '.slick-dots' );
								if ( null !== dotEl ) dotEl.style.setProperty( '--dot-animation-time', '6250ms' );
							}

							/**
							 * Only apply the parallax effect to the
							 * "slider-block", and if the direction is "right".
							 *
							 * @link
							 * https://stackoverflow.com/questions/27447382/how-to-detect-slide-direction-in-slick-carousel-onbeforechange
							 */
							if ( 'slider-block' === sliderName ) {

								if ( 1 === Math.abs( nextSlide - currentSlide ) ) {
									direction = ( 0 < nextSlide - currentSlide ) ? 'right' : 'left'; /* eslint-disable-line no-ternary */
								} else {
									direction = ( 0 < nextSlide - currentSlide ) ? 'left' : 'right'; /* eslint-disable-line no-ternary */
								}

								if ( 'right' === direction ) slick.$slides.eq( currentSlide ).addClass( 'parallax' );
							}

							if ( null !== sliderI ) sliderI.textContent = nextSlide + 1;
						})
						.on( 'afterChange', ( event, slick, currentSlide ) => {

							// Remove the "parallax" class from the previous slide.
							if ( 'slider-block' === sliderName ) {
								slick.$slider.find( '.parallax' ).removeClass( 'parallax' );
							}
						})
						.slick( options );
				}
			},
		}) );
	});
})( jQuery );
